/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/CheckCircle.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const CheckCircle: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" ref={ref} {...props}>
    <path
      fill={color}
      d="M15.125 6.938a.6.6 0 0 0-.469-.22q-.25 0-.469.22a.6.6 0 0 0-.187.437V8q0 2.47-1.781 4.25Q10.469 14 8 14q-2.468 0-4.25-1.75Q2 10.47 2 8q0-2.5 1.75-4.25Q5.532 2 8 2a5.8 5.8 0 0 1 2.438.531q.343.126.624-.062.313-.22.313-.563 0-.437-.375-.593a7.1 7.1 0 0 0-3-.657q-3.03 0-5.187 2.157T.656 8t2.157 5.188Q4.969 15.344 8 15.344a7.1 7.1 0 0 0 3.688-1 7.07 7.07 0 0 0 2.656-2.656 7.1 7.1 0 0 0 1-3.688v-.625a.56.56 0 0 0-.219-.437m.219-4.282a.6.6 0 0 0-.094-.312.7.7 0 0 0-.25-.25.66.66 0 0 0-.344-.094.64.64 0 0 0-.469.188L8 8.406 6.469 6.875A.64.64 0 0 0 6 6.688a.64.64 0 0 0-.469.187.64.64 0 0 0-.187.469q0 .28.187.468l2 2A.64.64 0 0 0 8 10a.64.64 0 0 0 .469-.187l6.656-6.688a.6.6 0 0 0 .219-.469"
    />
  </svg>
);
CheckCircle.displayName = "CheckCircle";
